import { useState } from "react";
import { Lock } from "lucide-react";
import { useLang, useT } from "../../i18n";
import { getCart, checkout } from "../../lib/shopApi";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export const CheckoutForm = () => {
  const t = useT();
  const lang = useLang();
  const [sending, setSending] = useState(false);
  const [error, setError] = useState("");
  const [form, setForm] = useState({
    email: "", first_name: "", last_name: "", address: "", postal_code: "",
  });
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const pay = async (e) => {
    e.preventDefault();
    setSending(true);
    setError("");
    try {
      const items = getCart().map((i) => ({ product_id: i.product_id, size_label: i.size_label, quantity: i.quantity }));
      const res = await checkout({
        items,
        customer: { ...form, city: t.sh_city_fixed, country: "Switzerland" },
        origin_url: window.location.origin,
        lang,
      });
      window.location.href = res.checkout_url;
    } catch (err) {
      setError(err.response?.data?.detail || "Error");
      setSending(false);
    }
  };

  const inputCls = "bg-white/80 border-bergamote-600/25 focus-visible:ring-bergamote-500 text-bergamote-900";

  return (
    <form onSubmit={pay} className="space-y-4" data-testid="checkout-form">
      <div className="grid sm:grid-cols-2 gap-4">
        <div className="space-y-1.5 sm:col-span-2">
          <Label className="text-bergamote-700 text-xs font-mono uppercase tracking-widest">{t.sh_email}</Label>
          <Input type="email" required value={form.email} onChange={set("email")} className={inputCls} data-testid="checkout-email" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-bergamote-700 text-xs font-mono uppercase tracking-widest">{t.sh_first}</Label>
          <Input required value={form.first_name} onChange={set("first_name")} className={inputCls} data-testid="checkout-first-name" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-bergamote-700 text-xs font-mono uppercase tracking-widest">{t.sh_last}</Label>
          <Input required value={form.last_name} onChange={set("last_name")} className={inputCls} data-testid="checkout-last-name" />
        </div>
        <div className="space-y-1.5 sm:col-span-2">
          <Label className="text-bergamote-700 text-xs font-mono uppercase tracking-widest">{t.sh_address}</Label>
          <Input required value={form.address} onChange={set("address")} className={inputCls} data-testid="checkout-address" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-bergamote-700 text-xs font-mono uppercase tracking-widest">{t.sh_postal}</Label>
          <Input required value={form.postal_code} onChange={set("postal_code")} className={inputCls} data-testid="checkout-postal" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-bergamote-700 text-xs font-mono uppercase tracking-widest">{t.sh_city}</Label>
          <Input value={t.sh_city_fixed} readOnly disabled className={`${inputCls} opacity-70 cursor-not-allowed`} data-testid="checkout-city" />
        </div>
      </div>
      <p className="text-xs text-bergamote-700/70">{t.sh_shipping_note}</p>
      {error && <p className="text-sm text-destructive" data-testid="checkout-error">{error}</p>}
      <button
        type="submit"
        disabled={sending}
        data-testid="checkout-pay-btn"
        className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-bergamote-600 text-cream-50 py-4 text-sm font-bold hover:bg-bergamote-700 disabled:opacity-60 transition-colors duration-300"
      >
        <Lock className="w-4 h-4" />
        {sending ? "…" : t.sh_pay}
      </button>
      <p className="text-[11px] font-mono text-center text-bergamote-500" data-testid="checkout-test-note">{t.sh_pay_note}</p>
    </form>
  );
};
